import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Input, OnInit, OnDestroy, ViewChild, NgZone, Renderer2, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { param } from 'jquery';
import { forkJoin, Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { AWS_IMAGE_URL, CHECKOUT_URL, IMAGES_URL, PRODUCT_URL } from '../../constants/constants';
import { AccountReponseData } from '../../interfaces/account';
import { CorpLocalStorageOfferData, CorpOfferListingData, CorpOfferResponseData } from '../../interfaces/corp-offer';
import { CorpShoppingCartResponseData } from '../../interfaces/corp-shopping';
import { DeliveryLocationResponseData, UserSearchDeliveryLocationInfo } from '../../interfaces/delivery';
import { EstablishmentResponseData } from '../../interfaces/establishment';
import { LocalStorageOfferData, OfferFilterCategoryInterface, OfferResponseData, OffersAllPageResponseData, OfferSlugResponseData } from '../../interfaces/offer';
import { BevviProduct, ProductResponseData } from '../../interfaces/product';
import { ShoppingCartResponseData, ShoppingCartUploadResponseData } from '../../interfaces/shopping';
import { ApiService } from '../../service/api.service';
import { CustomjsService } from '../../service/customjs.service';
import { LocalStorageService } from '../../service/localstorage.service';
import { UserService } from '../../service/user.service';

interface FilterInfo {
  filters?: {
    displayName?: string,
    value?: string
  }
  filterMatrix?: {
    row?: number,
    column?: number
  }
}

@Component({
  selector: 'bevvi-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss',
  './offer-skeleton.component.scss'
  ]
})
export class OfferComponent implements OnInit {

  @Input()
  offer: OfferFilterCategoryInterface;

  @Input()
  line: string;

  @Input()
  productArray: any;

  @Input()
  postProductData: boolean

  @Input()
  isTopSelling: boolean = false;

  @ViewChild('addAddress',{static: false})
  public addAddressRef: ElementRef

  // Home Page Offers
  public offerAllPages: CorpOfferResponseData;
  public productOfferInfo: Array<CorpOfferListingData>;
  public showProductOfferInfo: Array<CorpOfferListingData>;
  public showProductOfferInfoMobile: Array<CorpOfferListingData>;
  public bevviProductInfo: Array<BevviProduct>;
  public showBevviProductInfo: Array<BevviProduct>;
  public showBevviProductInfoMobile: Array<BevviProduct>;
  public offersFlag: boolean = false;
  public singleOfferFlag: boolean = false;
  public productZeroInfo: boolean = false;
  public imgURL = IMAGES_URL;
  public isLoggedIn: boolean = false;
  public showOffer: boolean = true;
  public address: string;
  public currPage: number = 1;
  public lastPage: number = 4;
  public bevviFlag: boolean = false;
  public showSkeleton: boolean = true;
  public categoryView: string;
  public latitude: number;
  public longitude: number;
  @ViewChild('searchMap', {static: true})
  public searchElementRef: ElementRef;
  @ViewChild('refresh', {static: false})
  public refreshRef: ElementRef;

  public errorMsg: string;
  public successMsg: string;

  public formattedAddress: string;
  public addressError: boolean = false;
  public loading: boolean = false;
  public userSearchDeliveryInfo: UserSearchDeliveryLocationInfo;
  public userAddress: object = {};

  private originalResponse: OfferSlugResponseData;

  // Public
  public isLocationPresent: boolean = false;
  public isOfferListPresent: boolean = false;
  public offerFetched: boolean = false;
  public itemAdded: boolean = false;
  public isOfferInfoPresent: boolean = false;
  public canAddToCart: boolean = true;
  public isProductImage: boolean = false;
  public offerList: Array<OfferResponseData>;
  public bevviProductList: Array<BevviProduct>;
  public AWS_IMAGE_URL = AWS_IMAGE_URL;
  public offerData: OfferResponseData;
  public productData: ProductResponseData;
  public establishmentData: EstablishmentResponseData;
  public itemCount: number = 1;
  public inCartCount: number = 0;
  public image: string = "assets/images/logo3x.png";
  private proceedFurther: boolean = false;
  public setSlugName: string = '';
  public establishmentIdData: any;
  public oldEstablishmentIDData: any;

  // ViewChild Variables
  @ViewChild('addToCart',{static: false})
  public addToCartRef: ElementRef;

  @ViewChild('otherStore', {static: true})
  public otherStoreRef: ElementRef;

  @ViewChild('qtyErrorDialog', {static:false})
  public qtyErrorDialogRef: ElementRef

  // @ViewChild('qtyErrorDialog', {static:false})
  // public qtyErrorDialogRef: ElementRef

  // Analytics Variables
  private gaScript_addtocart: any;
  private gaAddtoCartSet: boolean = false;
  private fbScript_viewcontent;
  private fbViewSet: boolean = false;
  private fbScript_addtocart: any;
  private fbAddtoCartSet: boolean = false;
  private klaviyoScript_addtocart: any;
  private klaviyoScriptAddtoCartSet: boolean = false;
  private fbMetaTagSet: boolean = false;


  constructor(
    private apiService: ApiService,
    private localStorage: LocalStorageService,
    private userService: UserService,
    private router: Router,
    private ngZone: NgZone,
    private customJSService: CustomjsService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private _ngZone: NgZone
  ) { }

  ngOnInit() {
    this.isLoggedIn = this.localStorage.isLoggedIn();
    this.address = this.localStorage.getUserSearchGeoLocationAddress();
    this.getPageOffers(this.offer)

    this.isLocationPresent = this.localStorage.getUserSearchGeoLocationAddress() ? true : false;

    this.userService.locationPresent$
    .subscribe(
      (data: boolean) => {
        if (data) {
          this.isLocationPresent = this.localStorage.getUserSearchGeoLocationAddress() ? true : false;
          this.offerList = [];
          this.isOfferListPresent = false;
          this.bevviProductList = [];
          // this.loadProducts();
        }
      }
    )
    // this.loadProducts();
    this.userService.setSlugName$
    .subscribe(
      (name: string) => {
        this.setSlugName = name ? name : '';
      }
    )

    this.userService.categoryViewSubject
    .subscribe(
      data => {
        this.categoryView = data ? data : 'all';
      }
    )

    // this.userService.changeLocationAddress$
    // .pipe(first())
    // .subscribe(
    //   (changeLocation: boolean) => {
    //     if (changeLocation) {
    //       console.log('CHANGE LOCATION IS CALLED')
    //       this.bevviFlag = false;
    //       this.offersFlag = false;
    //       this.showSkeleton = true;
    //       this.getPageOffers(this.offer,1);
    //     }
    //   }
    // )

    try {
      let autoComplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"]
      });

      autoComplete.addListener("place_changed", () => {
        let place: google.maps.places.PlaceResult = autoComplete.getPlace();

        if (place.geometry === undefined || place.geometry === null) {
          return;
        }
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.formattedAddress = place.formatted_address;
        // console.log('Place Changed');
        // console.log(place);

        place.address_components.forEach(data => {
          let type = data.types[0];
          let shortName = data.short_name;
          this.userAddress[type] = shortName
        })
        this.clickShopNow();
      });
    } catch {
      this.refreshRef.nativeElement.click();
    }

    this.isLoggedIn = this.localStorage.isLoggedIn();

    // this.userService.reloadOfferSubject
    // .subscribe(
    //   data => {
    //     if (data) {
    //       this.offersFlag = false;
    //       this.showSkeleton = true;
    //       this.getPageOffers(this.offer, 1);
    //     }
    //   }
    // )
  }

  // Send Data to Analytics
  googleAddtoCart(product: CorpOfferListingData) {
    if (this.gaAddtoCartSet) {
      this._renderer2.removeChild(this._document.body, this.gaScript_addtocart);
    }
    this.gaAddtoCartSet = true;
    this.gaScript_addtocart = this._renderer2.createElement('script');
    this.gaScript_addtocart.type = 'text/javascript';
    this.gaScript_addtocart.id = 'ga-track-addtocart';
    this.gaScript_addtocart.async = 'true';
    this.gaScript_addtocart.defer = 'true';

    // let localStorageCartData: Array<LocalStorageOfferData> = this.localStorage.getShoppingCartData();
    // let shoppingCartData: LocalStorageOfferData;

    // Object.keys(localStorageCartData).map((key) => {
    //   if (localStorageCartData[key]['id'] === offerID) {
    //     shoppingCartData = localStorageCartData[key]
    //   }
    // })

    this.gaScript_addtocart.text = `gtag('event', 'add_to_cart', {
      "items": [
        {
          "id": "${product.id}",
          "name": "${product.name}",
          "list_name": "Add Product To Cart",
          "brand": "",
          "category": "${product.category}",
          "variant": "${product.varietal}",
          "list_position": 1,
          "quantity": 1,
          "price": '${product.salePrice}'
        }
      ],
      "value": ${product.salePrice * 1},
    })`;


    this._renderer2.appendChild(this._document.body, this.gaScript_addtocart);
    // let productID = shoppingCartData['product']['bevviId'] ? shoppingCartData['product']['bevviId'] : shoppingCartData['product']['id'];
    this.facebookAddtoCart(product.salePrice, product.id, 1);
  }

  facebookAddtoCart(salePrice, id, quantity) {
    // console.log('facebookAddtoCart')
    this.fbAddtoCartSet = true;
    this.fbScript_addtocart = this._renderer2.createElement('script');
    this.fbScript_addtocart.type = 'text/javascript';
    this.fbScript_addtocart.id = 'fb-track-addtocart';
    this.fbScript_addtocart.async = 'true';
    this.fbScript_addtocart.defer = 'true';

    this.fbScript_addtocart.text = `fbq('track', 'AddToCart', {
      value: ${salePrice},
      currency: 'USD',
      contents: [
        {
          id: '${id}',
          quantity: ${quantity}
        }
      ],
      content_ids: '${id}',
      content_type: 'product'
    })`;
    // console.log(this.fbScript_addtocart.text)
    this._renderer2.appendChild(this._document.body, this.fbScript_addtocart);
  }

  klaviyoAddtoCart(product) {
    if (this.klaviyoScriptAddtoCartSet) {
      this._renderer2.removeChild(this._document.body, this.klaviyoScript_addtocart);
    }
    this.klaviyoScriptAddtoCartSet = true;
    this.klaviyoScript_addtocart = this._renderer2.createElement('script');
    this.klaviyoScript_addtocart.type = 'text/javascript';
    this.klaviyoScript_addtocart.id = 'klaviyo-track-addtocart';
    this.klaviyoScript_addtocart.async = 'true';
    this.klaviyoScript_addtocart.defer = 'true';

    let cartData = []
    let productNameInCart = []
    const shoppingCartData = this.localStorage.getShoppingCartData();

    for (const cart of shoppingCartData) {
      productNameInCart.push(cart.name)
      cartData.push({
        "ProductID": `${cart.id}`,
        "SKU": `${cart.sku}` || '',
        "ProductName": `${cart.name}`,
        "Quantity": 1,
        "ItemPrice": `${cart.price}`,
        "RowTotal": `${cart.price}`,
        "ProductURL": `${PRODUCT_URL}${cart.slug}`,
        "ImageURL": `${cart.imgFileName}`,
        "ProductCategories": []
      })
    }
    this.klaviyoScript_addtocart.text = `
      _learnq.push(["track", "Added to Cart", {
      "$value": '${product.salePrice}',
      "AddedItemProductName": '${product.name}',
      "AddedItemProductID": '${product.id}',
      "AddedItemSKU": '${product.sku}',
      "AddedItemCategories": ['${product.category}'],
      "AddedItemImageURL": '${IMAGES_URL}${product.image}',
      "AddedItemURL": '${PRODUCT_URL}${product.slug}',
      "AddedItemPrice": '${product.salePrice}',
      "AddedItemQuantity": 1,
      "ItemNames": '${productNameInCart}',
      "CheckoutURL": '${CHECKOUT_URL}',
      "Items": '${JSON.stringify(cartData)}'
    }])`;

    this._renderer2.appendChild(this._document.body, this.klaviyoScript_addtocart);
  }

  getPageOffers(offer: OfferFilterCategoryInterface, currPageNum: number = 1) {
    let params: any;
    let URL: string;
    let establishment: string;
    let data: any = {};
    // let product: Array<any> = [];

    if (true) {
      // let establishmentIDData = this.localStorage.getEstablishmentIDofAddress()
      if (this.isTopSelling) {
        URL = this.apiService.constants.CORPPORATE_TOP_PICKS_API;
        params = {}
      } else {
        if (this.isLoggedIn) {
          let filterStmt = '';
          if (offer.filters.length > 0) {
            filterStmt = offer.filters;
          }
          console.log('FILTER', filterStmt)
          params = {
            currentAccountId: this.localStorage.getCurrentAccountID(),
            // establishmentsID: JSON.stringify(establishmentIDData),
            // TODO: FOR TESTING PURPOSE OF PRODUCT RECO
            // currentAccountEmail: this.localStorage.getProductReco() ? this.localStorage.getProductReco() : this.localStorage.getAccountEmail(),
            currentAccountEmail: this.localStorage.getAccountEmail(),
            currPage: currPageNum,
            offersPerPage: 25,
            categoryType: offer.category ? offer.category.toUpperCase() : '',
            sort: 1,
            filtersData: encodeURIComponent(filterStmt),
            searchBy: offer.search ? offer.search : '',
            source: offer.source ? offer.source : ''
          }
          // URL = this.apiService.constants.GET_ALL_OFFER_ACCOUNTID_API;
          // URL = this.apiService.constants.GET_ALL_OFFER_GEOLOCATION_API_2
          const product = this.productArray ? this.productArray.filter((v, i, a) => a.findIndex(t => t.id === v.id) === i) : {};
          data = {
            offers: product
          }
          URL = this.apiService.constants.GET_ALL_CORPORATE_OFFERS_API
          
        } else {
  
          let filterStmt = '';
          if (offer.filters.length > 0) {
            filterStmt = offer.filters;
          }
          params = {
            // geoLocationParams: JSON.stringify(geoLocationInfo),
            // establishmentsID: JSON.stringify(establishmentIDData),
            currentAccountId: '5fd8a3d55f4e0a50683006b1',
            currentAccountEmail: 'noemailvisitor@getbevvi.com',
            currPage: currPageNum,
            offersPerPage: 25,
            categoryType: offer.category ? offer.category.toUpperCase() : '',
            sort: 1,
            filtersData: encodeURIComponent(filterStmt),
            searchBy: offer.search ? offer.search : '',
            source: offer.source ? offer.source : ''
          }
          // URL = this.apiService.constants.GET_ALL_OFFER_GEOLOCATION_API_2
          URL = this.apiService.constants.GET_ALL_CORPORATE_OFFERS_API
          // URL = this.apiService.constants.GET_ALL_OFFER_GEOLOCATION_API
          if (this.postProductData) {
            // console.log(this.productArray)
  
            const product = this.productArray ? this.productArray.filter((v, i, a) => a.findIndex(t => t.id === v.id) === i) : {};
            data = {
              offers: product
            }
          }
        }
      }

      this.apiService.getData(URL, params, true)
      .subscribe(
        (offersAllResponseData: CorpOfferResponseData) => {
          // console.log(offersAllResponseData.offers.length);
          // this.offerAllPages
          this.productOfferInfo = offersAllResponseData.offers;
          // this.establishmentIdData = offersAllResponseData.establishments;
          // this.oldEstablishmentIDData = this.localStorage.getEstablishmentIDofAddress();
          // console.log(this.oldEstablishmentIDData)
          // this.localStorage.setEstablishmentIDofAddress(this.establishmentIdData);
          if (this.productOfferInfo.length <= 4 ) {
            this.showOffer = false;
          }
          this.lastPage = this.productOfferInfo.length / 5;
          this.offersFlag = true;
          this.showSkeleton = false;
          this.productZeroInfo = false;
          // this.currPage = offersAllResponseData.curPageNum;
          // this.productOfferInfo.forEach((offer,index) => {
          //   if (offer.isSponsored) {
          //     this.productOfferInfo.splice(index,1);
          //   }
          // })
          this.checkProductAddedInCart();
          this.showProductOfferInfo = this.productOfferInfo.slice(0,5);
          this.showProductOfferInfoMobile = this.productOfferInfo.slice(0,this.productOfferInfo.length === 25 ? 15 : this.productOfferInfo.length);
          // this.checkAllProductInCart();
        }
      );

    }
  }

  routeToListing(offer) {
    console.log(offer)

    if (offer.category) { 
      if (offer.filters.includes('Wine Kits')) {
        // this.router.navigate(['/productlisting/wineKits?sortBy=high&filters=subCategory:Wine%20Kits'])
        this.router.navigate(['/productlisting/wineKits'], {queryParams: {sortBy: 'high', filters: 'subCategory:Wine Kits,Cocktail Kit'}});
      } else {
        this.router.navigate(['/productlisting/' + offer.category.toLowerCase()])
      }
    } else {
      this.router.navigate(['/productlisting/wine']);
    }
  }

  routeToDetail() {
    // if (this.offer.source === 'ProductPage') {
    //   window.scrollTo(0,0);
    // }
  }

  goToPage(num) {
    console.log(num)
    console.log(this.offersFlag)
    console.log(this.showProductOfferInfo)
    switch (num) {
      case 1:
        this.bevviFlag ? this.showBevviProductInfo = this.bevviProductInfo.slice(0,5) : '';
        this.offersFlag ? this.showProductOfferInfo = this.productOfferInfo.slice(0,5) : '';
        this.lastPage = this.productOfferInfo.length / 5;
        break;
      case 2:
        if (this.bevviFlag) {
          this.showBevviProductInfo = this.bevviProductInfo.slice(5,10);
          if (this.bevviProductInfo.slice(10,15).length < 5) {
            this.lastPage = num - 1;
          }
        } else if (this.offersFlag) {
          this.showProductOfferInfo = this.productOfferInfo.slice(5,10)
          if (this.productOfferInfo.slice(10,15).length < 5) {
            this.lastPage = num - 1;
          }
        }
        break;
      case 3:
        if (this.bevviFlag) {
          this.showBevviProductInfo = this.bevviProductInfo.slice(10,15);
          if (this.bevviProductInfo.slice(15,20).length < 5) {
            this.lastPage = num - 1;
          }
        } else if (this.offersFlag) {
          this.showProductOfferInfo = this.productOfferInfo.slice(10,15)
          if (this.productOfferInfo.slice(15,20).length < 5) {
            this.lastPage = num - 1;
          }
        }
        break;
      case 4:
        if (this.bevviFlag) {
          this.showBevviProductInfo = this.bevviProductInfo.slice(15,20);
          if (this.bevviProductInfo.slice(20,25).length < 5) {
            this.lastPage = num - 1;
          }
        } else if (this.offersFlag) {
          this.showProductOfferInfo = this.productOfferInfo.slice(15,20)
          if (this.productOfferInfo.slice(20,25).length < 5) {
            this.lastPage = num - 1;
          }
        }
        break;
      case 5:
        this.bevviFlag ? this.showBevviProductInfo = this.bevviProductInfo.slice(20,25) : '';
        this.offersFlag ? this.showProductOfferInfo = this.productOfferInfo.slice(20,25) : '';
        break;
    }
    this.currPage = num;
    this.checkAllProductInCart();
    console.log(this.productOfferInfo);
  }

  scrollUp() {
    window.scrollTo(0,0);
  }

  /**
   * Update Address
   */
  updateAddress() {
    if (this.searchElementRef.nativeElement.value != null && this.addressError) {
      this.addressError = false;
    }
    this.latitude = null;
    this.longitude = null;
  }

  clickShopNow() {

    this.loading = true;
    // console.log(this.userAddress)
    // console.log('Clicked');
    // console.log('Loading' + this.loading);
    // console.log('Latitude: '+ this.latitude )
    // console.log('Longitude: '+ this.longitude )
    // return;
    if ( this.latitude != null || this.longitude != null ) {
      this.addressError = false;
      this.userSearchDeliveryInfo = {
        "geoLocation": {
          "coordinates": [
            this.longitude,
            this.latitude
          ],
          "type": "Point"
        },
        "address": this.formattedAddress
      };
      let stateName;
      let zipCode;
      Object.keys(this.userAddress).forEach((key) => {
        if (key === 'administrative_area_level_1') {
          stateName = this.userAddress[key]
        } else if (key === 'postal_code') {
          zipCode = this.userAddress[key]
        }
        if (key === 'administrative_area_level_1') {
          if (this.userAddress[key] === 'CA') {
            this.localStorage.setCaliforniaProposition(true);
          } else {
            this.localStorage.setCaliforniaProposition(false);
          }
        }
      })

      let updateData = {
        addressComponent: this.userAddress
      }

      if (this.localStorage.isLoggedIn()) {
        // Get Delivery Location ID
        let deliveryData = {
          "accountId": this.localStorage.getCurrentAccountID(),
          // "locationId": locationData.id,
          "geoLocation": {
            "coordinates": [
              this.longitude,
              this.latitude
            ],
            "type": "Point"
          },
          "address": this.formattedAddress
        };
        // console.log(deliveryData);

        let param = {
          "currentAccountId": this.localStorage.getCurrentAccountID(),
          "accessToken": this.localStorage.getAccessToken()
        }
        this.apiService.putData(this.apiService.constants.ACCOUNT_DATA_API, updateData, param, true)
        .subscribe(
          (accountResponseData: AccountReponseData) => {
            this.localStorage.setUserAddressComponent(updateData);
            this.apiService.postData(this.apiService.constants.UPDATE_ACCOUNT_ON_REMARKETY, '', param, true)
            .subscribe();
          }
        )

        this.apiService.postData(this.apiService.constants.ADD_DELIVERY_LOCATION_API, deliveryData, {}, false)
        .subscribe(
          (deliveryLocationData: DeliveryLocationResponseData) => {
            this.localStorage.setUserSearchGeoLocationAddress(deliveryLocationData.address);
            this.localStorage.setUserSearchGeoLocationPoint(deliveryLocationData.geoLocation);
            let params = {
              geoLocationParams: JSON.stringify(this.userSearchDeliveryInfo.geoLocation),
              currentAccountId: this.localStorage.getCurrentAccountID(),
              stateName: stateName,
              zipCode: zipCode
            }
            this.userService.locationAddress(true);

            this.userService.locationInfo(true);
            this.apiService.getData(this.apiService.constants.GET_ESTABLISHMENTID_BYACCOUNTID, params, true)
            .subscribe(
              (data) => {
                // this.oldEstablishmentIDData = this.localStorage.getEstablishmentIDofAddress();
                this.localStorage.setEstablishmentIDofAddress(data)
                this.addAddressRef.nativeElement.click();
                this.ngZone.run(() => {
                  this.router.navigate(['/productlisting']);
                });
              },
              error => {
                console.log(error)
              }
            )
            // this.ngZone.run(() => {
            //   this.router.navigate(['/productlisting']);
            // });
          },
          error => {
            this.loading = false;
            this.errorHandle(error);
          }
        );
      } else {
        this.localStorage.setUserSearchGeoLocationPoint(this.userSearchDeliveryInfo.geoLocation);
        this.localStorage.setUserSearchGeoLocationAddress(this.userSearchDeliveryInfo.address);
        this.userService.locationInfo(true);
        this.userService.locationAddress(true);
        this.localStorage.setUserAddressComponent(updateData);
        this.localStorage.setUserDeliveryLocation(true);
        // console.log('Redirect to ProductListing');
        // this.loading = false;
        let params = {
          geoLocationParams: JSON.stringify(this.userSearchDeliveryInfo.geoLocation),
          stateName: stateName,
          zipCode: zipCode
        }
        this.apiService.getData(this.apiService.constants.GET_ESTABLISHMENTID_BYGEOLOCATION, params, true)
        .subscribe(
          (data) => {
            // this.oldEstablishmentIDData = this.localStorage.getEstablishmentIDofAddress();
            this.localStorage.setEstablishmentIDofAddress(data)
            this.addAddressRef.nativeElement.click();
            this.ngZone.run(() => {
              this.router.navigate(['/productlisting']);
            });
          },
          error => {
            console.log(error);
          }
        )

      }
    } else {
      this.loading = false;
      this.addressError = true;
      this.errorMsg = "Please enter a valid address and select from dropdown.";
    }
  }

  /**
   * Error Handle Function
   * @param error
   * @return void
   */
  errorHandle(error): void {
    this.addressError = true;
    if (error.status === 0) {
      this.errorMsg = "Please check your internet connection."
    } else if (error.status === 422) {
      this.errorMsg = "Validation error, try again.";
    } else {
      this.errorMsg = "Server Error, please refresh the page and try again."
    }
  }

  checkEstablishmentData(): boolean {
    let localStorageCartData: Array<LocalStorageOfferData> = this.localStorage.getShoppingCartData();

    let isPresent = false;
    if (this.proceedFurther) {
      return true;
    }
    if (localStorageCartData != null) {
      localStorageCartData.forEach(data => {
        if (data.establishmentId === this.offerData.establishmentId) {
          isPresent = true;
        }
      })
    } else {
      isPresent = true;
    }
    // console.log('TO Return: ' + isPresent);
    return isPresent;
  }

  private getShoppingCart(): Observable<any> {
    let params = {
      "currentAccountId": this.localStorage.getCurrentAccountID()
    };
    return this.apiService.getData(this.apiService.constants.CORPORATE_GETSHOPPING_CART_API, params, true)

  }

  updateLocalCartData(shoppingResponseData: Array<ShoppingCartResponseData>) {
    if (shoppingResponseData.length > 0) {
      let localStorageCartData: Array<LocalStorageOfferData> = [];
      shoppingResponseData.forEach((data:ShoppingCartResponseData) => {
        let cartData: LocalStorageOfferData = {
          id: data.offerId,
          name: data.offer.name,
          description: data.offer.description,
          establishmentId: data.offer.establishmentId,
          productId: data.offer.productId,
          cartId: this.isLoggedIn ? data.id : null,
          product : {
              id: data.product.id,
              name: data.product.name,
              category: data.product.category,
              description: data.product.description,
              bevviId: data.product.bevviId ? data.product.bevviId : data.product.id,
              imgFileName: this.productData.image ? this.productData.image : 'placeholder-small.png',
              variant: this.productData.color ? this.productData.color : null,
              slug: this.productData.slug ? this.productData.slug : null,
              size: this.productData.size ? this.productData.size: null,
              units: this.productData.units ? this.productData.units: null,
          },
          establishment: {
            id: data.offer.establishment.id,
            name: data.offer.establishment.name,
            email: data.offer.establishment.email,
            category: data.offer.establishment.category,
            percentDiscount: data.offer.establishment.percentDiscount,
            percentLiquorDiscount: data.offer.establishment.percentLiquorDiscount,
          },
          quantity: data.quantity
        };

        localStorageCartData.push(cartData)

      });
      this.localStorage.setShoppingCartData(localStorageCartData);

      let cartQty = this.localStorage.getCartQuantityFromLocalStorage();
      this.userService.loadCartQty(cartQty);
      return true;
    }
    return false;
  }

  checkProductInCart(offerID) {
    let localCartData: Array<LocalStorageOfferData> = this.localStorage.getShoppingCartData();

    if (localCartData != null) {
      for (const cart of localCartData) {
        if (cart.id === offerID) {
          console.log(cart.id, offerID)
          this.itemAdded = true;
          this.inCartCount = cart.quantity;
        }
      }
    }
  }

  checkAllProductInCart() {
    let localCartData: Array<LocalStorageOfferData> = this.localStorage.getShoppingCartData();
    if (localCartData != null) {
      for (const data of localCartData) {
        for (const offer of this.showProductOfferInfo) {
          if (data.id === offer.id) {
            offer.isInCart = true;
            
          }
        }
      }
    }
  }

  setInCartForDesktopMobile(productId) {
    if (this.showProductOfferInfoMobile && this.showProductOfferInfoMobile.length > 0) {
      for (const data of this.showProductOfferInfoMobile) {
        if (data.id === productId) {
          data.isInCart = true;
        }
      }
    }
    if (this.showProductOfferInfo && this.showProductOfferInfo.length > 0) {

      for (const data of this.showProductOfferInfo) {
        if (data.id === productId) {
          data.isInCart = true;
        }
      }
    }
  }

  checkProductAddedInCart() {
    const localCartData: Array<CorpLocalStorageOfferData> = this.localStorage.getShoppingCartData();
    if (localCartData) {
      for (const data of localCartData) {
        for (const product of this.productOfferInfo) {
          if (product.id === data.id) {
            product.isInCart = true;
            this.setInCartForDesktopMobile(data.id);
          }
        }
      }
    }
  }

  private updateLocalStorageCart() {
    let localStorageCartData: Array<LocalStorageOfferData> = this.localStorage.getShoppingCartData();

    if (localStorageCartData === null) {
      let localCartData: Array<LocalStorageOfferData> = [];
      localCartData['0'] = {
        id: this.offerData.id,
        name: this.offerData.name,
        description: this.offerData.description,
        establishmentId: this.offerData.establishmentId,
        productId: this.offerData.productId,
        cartId: null,
        product : {
            id: this.productData.id,
            name: this.productData.name,
            category: this.productData.category,
            description: this.productData.description,
            bevviId: this.productData.bevviId ? this.productData.bevviId : this.productData.id,
            imgFileName: this.productData.image ? this.productData.image : 'placeholder-small.png',
            variant: this.productData.color ? this.productData.color : null,
            slug: this.productData.slug ? this.productData.slug : null,
            size: this.productData.size ? this.productData.size: null,
            units: this.productData.units ? this.productData.units: null,
        },
        establishment: {
            id: this.establishmentData.id,
            name: this.establishmentData.name,
            email: this.establishmentData.email,
            category: this.establishmentData.category,
            percentDiscount: this.establishmentData.percentDiscount,
            percentLiquorDiscount: this.establishmentData.percentLiquorDiscount,
        },
        quantity: this.itemCount
      }

      // console.log(localCartData);
      this.localStorage.setShoppingCartData(localCartData);
      return true;

    } else {
      let updateData = false;
      localStorageCartData.forEach((localData: LocalStorageOfferData) => {


        // Check if present Product is in cart ,
        if ( localData.id === this.offerData.id ) {
          // if yes then update quantity for present product
          localData.quantity = this.itemCount + localData.quantity;
          updateData = true;
        }

        this.localStorage.setShoppingCartData(localStorageCartData);
      });

      if (!updateData) {
        // If no, then add present product in cartData
        let cartData: LocalStorageOfferData = {
          id: this.offerData.id,
          name: this.offerData.name,
          description: this.offerData.description,
          establishmentId: this.offerData.establishmentId,
          productId: this.offerData.productId,
          cartId: null,
          product : {
              id: this.productData.id,
              name: this.productData.name,
              category: this.productData.category,
              description: this.productData.description,
              bevviId: this.productData.bevviId ? this.productData.bevviId : this.productData.id,
              imgFileName: this.productData.image ? this.productData.image : 'placeholder-small.png',
              variant: this.productData.color ? this.productData.color : null,
              slug: this.productData.slug ? this.productData.slug : null,
              size: this.productData.size ? this.productData.size: null,
              units: this.productData.units ? this.productData.units: null,
          },
          establishment: {
              id: this.establishmentData.id,
              name: this.establishmentData.name,
              email: this.establishmentData.email,
              category: this.establishmentData.category,
              percentDiscount: this.establishmentData.percentDiscount,
              percentLiquorDiscount: this.establishmentData.percentLiquorDiscount,
          },
          quantity: this.itemCount
        };

        // console.log(cartData);
        localStorageCartData.push(cartData);
        this.localStorage.setShoppingCartData(localStorageCartData);
      }

      return true;
    }
    return false;
  }

  canAdd() {
    this.proceedFurther = true;
    // console.log(this.setSlugName)
    this.addItemToCart(this.setSlugName);
    this.userService.getSlugName('');
  }

  notAdd() {
    this.customJSService.addToCartLoading(this.setSlugName, false);
    this.setSlugName = ''
  }

  addItemToCorpCart(productId) {
    console.log(productId)
    // this.customJSService.addToCartLoading(productId, true);
    
    for (const product of this.productOfferInfo) {
      if (product.id === productId) {
        console.log('Add this in cart');
        product.isAddingCart = true;
        console.log(product)
        
        
        if (this.isLoggedIn) {
          const params = {
            accountId: this.localStorage.getCurrentAccountID(),
            quantity: 1,
            corpProductId: productId
          }
          this.apiService.postData(this.apiService.constants.CORPORATE_ADD_TO_SHOPPING_CART_POST_API, params, {}, false)
          .subscribe(
            (responseData: any) => {
              this.getShoppingCart()
              .subscribe(
                (responseData: Array<CorpShoppingCartResponseData>) => {
                  this.customJSService.addToCartLoading(productId, false);
                  this.successMsg = 'Product Successfully Added To Cart.';
                  this.userService.flashMsg(true);
                  product.isAddingCart = false;
                  // this.addToLocalCart(product)
                  this.addCorpShoppingResponseToLocalCart(responseData)
                  this.checkProductAddedInCart();
                  this.googleAddtoCart(product);
                  this.klaviyoAddtoCart(product)
                  // this.userService.reloadCartProductData(true);
                }
              )
            },
            (error) => {
              this.customJSService.addToCartLoading(productId, false);
              product.isAddingCart = false;
              this.errorMsg = 'Something went wrong. Please try again later.';
              this.userService.flashMsg(true);
            }
          )
        } else {
          this.addToLocalCart(product)
          this.customJSService.addToCartLoading(productId, false);
          this.checkProductAddedInCart();
          this.googleAddtoCart(product)
          this.klaviyoAddtoCart(product)
          product.isAddingCart = false;
          // this.userService.reloadCartProductData(true);
        }
      }
    }
  }

  addToLocalCart(productData: CorpOfferListingData) {
    
    const localCartData: Array<CorpLocalStorageOfferData> = this.localStorage.getShoppingCartData() || [];
    const shoppingData: CorpLocalStorageOfferData = {
      id: productData.id,
      name: productData.name,
      description: productData.description,
      imgFileName: productData.image,
      slug: productData.slug,
      size: productData.size,
      units: productData.units,
      variant: productData.varietal,
      price: productData.salePrice,
      quantity: 1
    }
    localCartData.push(shoppingData)
    this.localStorage.setShoppingCartData(localCartData);
    this.userService.loadCartQty(this.localStorage.getCartQuantityFromLocalStorage())
  }

  addCorpShoppingResponseToLocalCart(shoppingResponseData: Array<CorpShoppingCartResponseData>) {
    const localCartData: Array<CorpLocalStorageOfferData> = [];
    for (const data of shoppingResponseData) {
      localCartData.push({
        id: data.corpProductId,
        name: data.corpProduct.name,
        description: data.corpProduct.description,
        imgFileName: data.corpProduct.image,
        slug: data.corpProduct.slug,
        size: data.corpProduct.size,
        units: data.corpProduct.units,
        variant: data.corpProduct.varietal,
        quantity: data.quantity,
        price: data.corpProduct.salePrice,
        cartId: data.id
      })
    }
    this.localStorage.setShoppingCartData(localCartData);
    this.userService.loadCartQty(this.localStorage.getCartQuantityFromLocalStorage())
  }
  
  addItemToCart(slugName) {
    // console.log('ADD TO CART INIT')
    if (true) {
      this.addToCartRef.nativeElement.innerHTML = "ADDING <i class='fa fa-pulse fa-spinner' style='margin-left:10px'></i>";
      this.customJSService.addToCartLoading(slugName, true);
      this.userService.getSlugName(slugName);
      let establishmentDataObject:object = this.localStorage.getEstablishmentIDofAddress();
      if (establishmentDataObject) {
        let param;
        let count = 0;
        let res1: OfferSlugResponseData;
        let res2: OfferSlugResponseData;

        let param1 = {
          "slugName": slugName,
          "establishmentID": establishmentDataObject['establishmentId'] != -1 ? establishmentDataObject['establishmentId'] : '',
          "isShipping": establishmentDataObject['isShipping'] ? establishmentDataObject['isShipping'] : false
        }

        let param2 = {
          "slugName": slugName,
          "establishmentID": establishmentDataObject['otherEstablishmentId'] != -1 ? establishmentDataObject['otherEstablishmentId'] : '',
          "isShipping": establishmentDataObject['isShipping'] ? establishmentDataObject['isShipping'] : false
        }

        // console.log('ADD TO CART FORK JOIN')
        forkJoin (
          this.apiService.getData(this.apiService.constants.GET_OFFER_DETAILS_VIA_SLUG_API, param1, true),
          this.apiService.getData(this.apiService.constants.GET_OFFER_DETAILS_VIA_SLUG_API, param2, true)
        )
        .subscribe( (data) => {
          // console.log(data);
          let offer1: OfferSlugResponseData = data[0];
          let offer2: OfferSlugResponseData = data[1];
          if (offer1.offerPresent) {
            this.offerData = offer1.offer ? offer1.offer : offer1.bevviproduct;
            // console.log('Offer is Present in 1')
            this.originalResponse = offer1;
            if (!offer1.offer && offer1.bevviproduct) {
              this.offerData.product = offer1.bevviproduct;
              this.originalResponse.offerPresent = false;
            } else if (offer1.bevviproduct) {
              this.offerData.product.bevviId = offer1.bevviproduct.id;
            } else if (!offer1.bevviproduct) {
              this.offerData.product.bevviId = offer1.offer.productId;
            }

          } else if (offer2.offerPresent) {
            this.offerData = offer2.offer ? offer2.offer : offer2.bevviproduct;
            // console.log('Offer is Present in 2')
            this.originalResponse = offer1;
            if (!offer2.offer && offer2.bevviproduct) {
              this.offerData.product = offer2.bevviproduct;
              this.originalResponse.offerPresent = false;
            } else if (offer2.bevviproduct) {
              this.offerData.product.bevviId = offer2.bevviproduct.id;
            } else if (!offer2.bevviproduct) {
              // console.log(offer2.offer)
              // console.log(this.offerData)
              this.offerData.product.bevviId = offer2.offer.productId;
            }
          } else {
            // console.log('Offer is not Present')
          }
          // Check if Product is in Cart
          this.checkProductInCart(this.offerData.id);
          if (this.offerData.remQty === 0) {
            this.canAddToCart = false;
          }

          this.isOfferInfoPresent = true;
          this.productData = this.offerData.product;
          this.establishmentData = this.offerData.establishment;


          // console.log('SEND CALL TO')
          this.addToCart(slugName);
        })


      } else {
        // this.userService.openAddressModal('home');
        this.customJSService.addToCartLoading(slugName, false);
        // this.addToCartRef.nativeElement.innerHTML = "ADD TO CART";
      }

    } else {
      // this.userService.openAddressModal('home');
      // this.customJSService.addToCartLoading(slugName, false);
      this.customJSService.addToCartLoading(slugName, false);
      // this.addToCartRef.nativeElement.innerHTML = "ADD TO CART";
    }
  }

  addToCart(slugName) {
    // console.log('CART ADD INIT')
    if (this.itemCount === null || this.itemCount < 0) {
      // this.addToCartRef.nativeElement.innerHTML = 'ADDED';
      this.customJSService.addToCartLoading(slugName, false);
      // this.addToCartRef.nativeElement.innerHTML = "ADD TO CART";
      return;
    }

    // Check if any product of these store is present in cart.
    if (this.checkEstablishmentData()) {
      // Check if User is Logged In,
      console.log(this.inCartCount, this.itemCount);
      if ((this.inCartCount + this.itemCount) <= this.offerData.remQty) {
        if ( this.isLoggedIn ) {
          let params = {
            currentAccountId: this.localStorage.getCurrentAccountID(),
            quantity: this.itemCount,
            productID: this.productData.id,
            offerID: this.offerData.id,
            establishmentID: this.offerData.establishmentId
          };

          // console.log('Add TO SHOPPING CART');

          // If Yes, then send Data To server
          this.apiService.getData(this.apiService.constants.CORPORATE_ADD_TO_SHOPPING_CART_API, params, true)
          .subscribe(
            (responseData: ShoppingCartUploadResponseData) => {
              // Call UpdateLocalStorage function
              // if ( this.updateLocalStorageCart() ) {
              //   this.userService.loadCartQty(this.localStorage.getCartQuantityFromLocalStorage());
              //   this.addToCartRef.nativeElement.innerHTML = 'Added';
              //   this.addToCartRef.nativeElement.innerHTML = 'ADD MORE TO CART';
              // }
              this.getShoppingCart()
              .subscribe(
                (responseShoppingData: Array<ShoppingCartResponseData>) => {
                  if ( this.updateLocalCartData(responseShoppingData) ){
                    this.customJSService.addToCartLoading(slugName, false);
                    // this.addToCartRef.nativeElement.innerHTML = "ADD TO CART";
                    this.checkProductInCart(this.offerData.id);
                    this.checkAllProductInCart();
                  }
                  // this.googleAddtoCart(this.offerData['salePrice'], this.offerData['id']);
                  // this.userService.showCartModal(true);
                  this.userService.flashMsg(true);
                  this.successMsg = 'Product Successfully Added To Cart.';
                  // console.log(this.offer.source)
                  if (this.offer.source.toLowerCase() === 'cart') {
                    // console.log('REload CART PRODUCT DATA')
                    this.userService.reloadCartProductData(true);
                  }
                },
                error => {
                  // console.log(error);
                }
              );
            },
            error => {
              // console.log(error);
              // Retry to send data to server
            }
          );

        } else {
          if ( this.updateLocalStorageCart() ) {
            this.userService.loadCartQty(this.localStorage.getCartQuantityFromLocalStorage());
            // this.addToCartRef.nativeElement.innerHTML = 'ADDED';
            // this.addToCartRef.nativeElement.innerHTML = "ADD TO CART";
            this.customJSService.addToCartLoading(slugName, false);
            this.checkProductInCart(this.offerData.id);
            this.checkAllProductInCart();
            // this.googleAddtoCart(this.offerData['salePrice'], this.offerData['id']);
            // console.log('SHOW CART MODal')
            this.userService.flashMsg(true);
            this.successMsg = 'Product Successfully Added To Cart.';
            if (this.offer.source.toLowerCase() === 'cart') {
              this.userService.reloadCartProductData(true);
            }
            // this.userService.showCartModal(true);
          }
        }
      } else {
        this.qtyErrorDialogRef.nativeElement.click();
        this.customJSService.addToCartLoading(slugName, false);
        // this.addToCartRef.nativeElement.innerHTML = "ADD TO CART";
      }
    } else {
      // console.log(this.setSlugName)
      // this.btnRef.nativeElement.setAttribute('data-slug',this.setSlugName);
      this.otherStoreRef.nativeElement.click();

    }
  }

  ngOnDestroy() {
    // console.log('CALLED ON DESTROY IN OFFER')
    // this.userService.reloadOfferSubject.unsubscribe();
    if (this.fbAddtoCartSet) {this._renderer2.removeChild(this._document.body, this.fbScript_addtocart);}
    if (this.gaAddtoCartSet) {this._renderer2.removeChild(this._document.body, this.gaScript_addtocart);}
    if (this.klaviyoScriptAddtoCartSet) {this._renderer2.removeChild(this._document.body, this.klaviyoScript_addtocart);}
  }
}
